import {
  API_ERROR,
  SHOW_SPINNER,
  HIDE_SPINNER,
  SET_APP_MODE,
  SET_APP_MODULE,
  SET_MOBILE,
  SET_COMMON_SOUNDS,
  SHOW_FORWARD_BUTTON,
  HIDE_FORWARD_BUTTON,
  SET_PULSE_TIMESTAMP,
  SET_MIC_PERMISSIONS,
  CLEAR_COMMON_SOUNDS,
  SET_ACTIVITY_TIMESTAMP,
  SHOW_VISUAL_CUE,
  HIDE_VISUAL_CUE,
  SET_LITE_VERSION,
  SET_ACCESSIBILITY_MODE
} from '../types/ui';

// eslint-disable-next-line no-unused-vars
import { loadApplicationAssets, loadCommonSfx, loadModuleAssets } from 'utils/loadAssets';

export const showSpinner = () => ({ type: SHOW_SPINNER });
export const hideSpinner = () => ({ type: HIDE_SPINNER });
export const setAppMode = mode => ({ type: SET_APP_MODE, payload: mode });
export const setModule = module => ({ type: SET_APP_MODULE, payload: module });
export const logApiError = error => ({ type: API_ERROR, payload: error });
export const setMobile = isMobile => ({ type: SET_MOBILE, payload: isMobile });
export const showVisualCue = message => ({ type: SHOW_VISUAL_CUE, payload: message });
export const hideVisualCue = () => ({ type: HIDE_VISUAL_CUE });

export const setCommonSounds = sounds => ({ type: SET_COMMON_SOUNDS, payload: sounds });
export const clearCommonSounds = () => ({ type: CLEAR_COMMON_SOUNDS });

export const showForwardButton = (isDone = true) => ({
  type: SHOW_FORWARD_BUTTON,
  payload: isDone
});

export const hideForwardButton = () => ({ type: HIDE_FORWARD_BUTTON });
export const flashForwardButton = () => ({ type: SET_PULSE_TIMESTAMP, payload: Date.now() });
export const setMicPermissions = flag => ({ type: SET_MIC_PERMISSIONS, payload: flag });

export const setActivityTimestamp = () => ({
  type: SET_ACTIVITY_TIMESTAMP,
  payload: new Date().getTime()
});

export const loadCommonAssets = () => async (dispatch, getState) => {
  const {
    ui: { module },
    login: { modules }
  } = getState();

  if (!module || module === '' || module === 'a-z-mat-man') return;

  const currentModule = modules.find(appModule => appModule.module === module);

  dispatch(showSpinner());

  const sounds =
    module === 'app-selection'
      ? await loadApplicationAssets() // loadCommonSfx
      : await loadModuleAssets(currentModule.moduleAssets);

  dispatch(setCommonSounds(sounds));
  dispatch(hideSpinner());
};

export const unloadCommonSounds = () => (dispatch, getState) => {
  const {
    ui: {
      sounds: { common }
    }
  } = getState();

  /* eslint-disable no-unused-vars */
  for (const snd in common) {
    'unload' in snd && snd.unload();
  }
  /* eslint-enble no-unused-vars */

  dispatch(clearCommonSounds());
};

export const setLiteVersion = isLite => ({
  type: SET_LITE_VERSION,
  payload: isLite
});

export const setAccessibilityMode = hasAccessibilityMode => ({
  type: SET_ACCESSIBILITY_MODE,
  payload: hasAccessibilityMode
});
